<template>
  <base-stat-item :metric="metric" label="Enquiry Via Phone">
    <template v-slot:icon>
      <phone-enquiry-icon></phone-enquiry-icon>
    </template>
  </base-stat-item>
</template>
<script>
import BaseStatItem from './BaseStatItem.vue';
import PhoneEnquiryIcon from '../Icons/PhoneEnquiryIcon.vue';

export default {
  props: {
    metric: [String, Number],
  },
  components: {
    BaseStatItem,
    PhoneEnquiryIcon,
  },
};
</script>
